import { render, staticRenderFns } from "./UploadMP4.vue?vue&type=template&id=2418768c&scoped=true&"
import script from "./UploadMP4.vue?vue&type=script&lang=js&"
export * from "./UploadMP4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2418768c",
  null
  
)

export default component.exports